import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { nothing as w } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';

class CardItem extends s {
    constructor() {
        super(...arguments);
        this.imageSrc = '';
        this.imageAlt = '';
        this.title = '';
        this.description = '';
        this.meta = '';
        this.tags = '';
        this.modalMeta = '';
        this.modalPrimaryCtaLink = '';
        this.modalPrimaryCtaLabel = '';
        this.modalSecondaryCtaLink = '';
        this.modalSecondaryCtaLabel = '';
    }
    render() {
        return w;
    }
    toCardItem() {
        return {
            imageSrc: this.imageSrc || undefined,
            imageAlt: this.imageAlt || undefined,
            title: this.title,
            description: this.description || undefined,
            meta: this.meta || undefined,
            tags: this.tags ? this.tags.split(',').map(t => t.trim()) : undefined,
            modalMeta: this.modalMeta || undefined,
            modalPrimaryCtaLink: this.modalPrimaryCtaLink || undefined,
            modalPrimaryCtaLabel: this.modalPrimaryCtaLabel || undefined,
            modalSecondaryCtaLink: this.modalSecondaryCtaLink || undefined,
            modalSecondaryCtaLabel: this.modalSecondaryCtaLabel || undefined,
        };
    }
}
__decorate([
    e({ type: String, attribute: 'image-src' })
], CardItem.prototype, "imageSrc", void 0);
__decorate([
    e({ type: String, attribute: 'image-alt' })
], CardItem.prototype, "imageAlt", void 0);
__decorate([
    e({ type: String })
], CardItem.prototype, "title", void 0);
__decorate([
    e({ type: String })
], CardItem.prototype, "description", void 0);
__decorate([
    e({ type: String })
], CardItem.prototype, "meta", void 0);
__decorate([
    e({ type: String })
], CardItem.prototype, "tags", void 0);
__decorate([
    e({ type: String, attribute: 'modal-meta' })
], CardItem.prototype, "modalMeta", void 0);
__decorate([
    e({ type: String, attribute: 'modal-primary-cta-link' })
], CardItem.prototype, "modalPrimaryCtaLink", void 0);
__decorate([
    e({ type: String, attribute: 'modal-primary-cta-label' })
], CardItem.prototype, "modalPrimaryCtaLabel", void 0);
__decorate([
    e({ type: String, attribute: 'modal-secondary-cta-link' })
], CardItem.prototype, "modalSecondaryCtaLink", void 0);
__decorate([
    e({ type: String, attribute: 'modal-secondary-cta-label' })
], CardItem.prototype, "modalSecondaryCtaLabel", void 0);
customElements.define('card-item', CardItem);

export { CardItem };
